import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


// routing 
import { Finanzas  } from 'app/finanzas/finanzas.routing.module';


// Components
import { EmpresasComponent } from 'app/finanzas/components/empresas/empresas.component';
import { FinanzasComponent } from 'app/finanzas/finanzas.component';
import { MovimientosComponent } from 'app/finanzas/components/movimientos/movimientos.component';
import { MovimientosxAnioComponent } from 'app/finanzas/components/movimientosx-anio/movimientosx-anio.component';

import { ComprobanteComponent } from 'app/finanzas/components/comprobante/comprobante.component';
import { ComprobantexAnioComponent } from 'app/finanzas/components/comprobantex-anio/comprobantex-anio.component';
import { InformeComponent } from 'app/finanzas/components/informe/informe.component';


import {  ValoracionComponent } from 'app/finanzas/components/valoracion/valoracion.component'
import { MenuValoracion } from 'app/finanzas/components/menu-valoracion/menu-valoracion.component' 


// Modals
import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';
import { PucComponent } from 'app/finanzas/modals/puc/puc.component';
import { AggPucComponent } from 'app/finanzas/modals/agg-puc/agg-puc.component';
import { FormGastos } from './modals/form-bitacora/gastos/form-gastos.component';
import { FormIngresos } from './modals/form-bitacora/ingresos/form-ingresos.component';
import { FormComprobanteComponent } from './modals/form-comprobante/form-comprobante.component';
import { AggRotacionUsu } from './modals/AggRotacionUsu/aggRotacionUsu.component';
import { RelGastos } from 'app/finanzas/modals/relGastos/relGastos.component';



import { NgxPaginationModule } from 'ngx-pagination';

// Angular material 
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import {MatTabsModule} from '@angular/material/tabs';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';

import {MatPaginatorModule} from '@angular/material/paginator';
import { DirectivesModule } from 'app/directives/directives/directives.module';

import { ChartsModule } from 'ng2-charts';
import { NgxSelectModule } from 'ngx-select-ex';


@NgModule({

  declarations: [
    // components
    EmpresasComponent,
    FinanzasComponent,
    MovimientosComponent,
    MovimientosxAnioComponent,
    ComprobanteComponent,
    ComprobantexAnioComponent,
    InformeComponent, 
    ValoracionComponent, 
    MenuValoracion, 

    


    // modals
    ConsultaFechaComponent,
    PucComponent,
    AggPucComponent,
    FormGastos,
    FormIngresos,
    FormComprobanteComponent,
    AggRotacionUsu, 
    RelGastos, 
    



  ],

  entryComponents:[
    ConsultaFechaComponent,
    PucComponent,
    AggPucComponent, 
    FormGastos, 
    FormIngresos,
    FormComprobanteComponent,
    AggRotacionUsu,
    RelGastos, 

  ],

  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxPaginationModule,
    Finanzas,
    DirectivesModule,
    ChartsModule, 
    NgxSelectModule, 
    

    
    // Angular Material 
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule, 
    MatCheckboxModule,
    MatCardModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTreeModule,
    MatIconModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatTabsModule,
    MatListModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTooltipModule,
  ],

  exports:[
    DirectivesModule
  ],


  bootstrap: [FinanzasComponent ]

  
})


export class FinanzasModule { }
